<!--基本信息-->
<template>
  <div class="essential">
    <!--工商信息-->
    <div ref="basic0" class="business">
      <div class="title-min SourceHanSansCN">工商信息</div>
      <div style="padding: 0px 30px 20px;">
        <table class="business-table">
          <tr>
            <td class="col-td4 border-left">统一社会信用代码</td>
            <td class="col-td7 border-left">{{ businessData.unifiedSocialCreditCode || '-' }}</td>
            <td class="col-td4 border-left">企业名称</td>
            <td class="col-td7 border-left" colspan="3">{{ businessData.companyName || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">法定代表人</td>
            <td class="col-td6 border-left">{{ businessData.legalPerson }}</td>
            <td class="col-td4 border-left">登记状态</td>
            <td class="col-td6 border-left">{{ businessData.status || '-' }}</td>
            <td class="col-td4 border-left">成立日期</td>
            <td class="col-td6 border-left">{{ businessData.establishTime || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">注册资本</td>
            <td class="col-td6 border-left">{{ businessData.registeredCapital || '-' }}</td>
            <td class="col-td4 border-left">实缴资本</td>
            <td class="col-td6 border-left">{{ businessData.paidCapital || '-' }}</td>
            <td class="col-td4 border-left">核准日期</td>
            <td class="col-td6 border-left">{{ businessData.approvalDate || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">组织机构代码</td>
            <td class="col-td6 border-left">{{ businessData.organizationCode || '-' }}</td>
            <td class="col-td4 border-left">工商注册号</td>
            <td class="col-td6 border-left">{{ businessData.businessRegistrationNumber || '-' }}</td>
            <td class="col-td4 border-left">纳税人识别</td>
            <td class="col-td6 border-left">{{ businessData.dutyNumber || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">企业类型</td>
            <td class="col-td6 border-left">{{ businessData.companyType || '-' }}</td>
            <td class="col-td4 border-left">营业期限</td>
            <td class="col-td6 border-left">{{ businessData.businessTerm || '-' }}</td>
            <td class="col-td4 border-left">纳税人资质</td>
            <td class="col-td6 border-left">{{ businessData.taxpayerQualification || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">所属行业</td>
            <td class="col-td6 border-left">{{ businessData.industryName || '-' }}</td>
            <td class="col-td4 border-left">所属地区</td>
            <td class="col-td6 border-left">{{ businessData.cityName || '-' }}</td>
            <td class="col-td4 border-left">登记机关</td>
            <td class="col-td6 border-left">{{ businessData.registrationAuthority || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">人员规模</td>
            <td class="col-td6 border-left">{{ businessData.scale || '-' }}</td>
            <td class="col-td4 border-left">参保地区</td>
            <td class="col-td6 border-left">{{ businessData.city || '-' }}</td>
            <td class="col-td4 border-left">曾用名</td>
            <td class="col-td6 border-left">{{ businessData.nameUsedBefore || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">英文名</td>
            <td class="col-td7 border-left">{{ businessData.englishName || '-' }}</td>
            <td class="col-td4 border-left">进出口企业代码</td>
            <td class="col-td7 border-left" colspan="3">{{ businessData.importExportEnterprisesCode || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">注册地址</td>
            <td class="col-td5 border-left" colspan="5">{{ businessData.address || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td4 border-left">经营范围</td>
            <td class="col-td5 border-left" colspan="5">{{ businessData.businessScope || '-' }}</td>
          </tr>
        </table>
      </div>
    </div>
    <!--股权穿透图-->
    <div ref="basic1" class="essential-content">
      <div class="title-min SourceHanSansCN">股权穿透图</div>
      <div style="padding: 0px 30px 20px;">
        <div :span="24" class="light-blue">{{ basicInfo.companyName }}</div>
        <div v-loading="g_loading" style="margin: 0px 30px;width:auto;height:500px;" ref="myPage">
          <SeeksRelationGraph ref="seeksRelationGraph" :options="graphOptions">
            <div slot="node" slot-scope="{node}">
              {{ node.text }}
            </div>
          </SeeksRelationGraph>
        </div>
      </div>
    </div>
    <!--股东信息-->
    <div ref="basic2" class="essential-content">
      <div class="title-min SourceHanSansCN">股东信息</div>
      <vxe-table resizable border ref="shareholder" :data="ShareholderInfo" align="center"
                 style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号"></vxe-column>
        <vxe-column field="shareholderName" title="股东及出资信息" align="left">
          <template #default="{ row }">
            <div style="display: flex;align-items: center;">
              <el-image shape="square" fit="contain" style="width: 45px;height: 45px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                        draggable="false" :src="row.shareholderLogo" v-if="row.shareholderLogo!=null && row.shareholderLogo!='' && row.shareholderLogo!='None' &&
                    row.shareholderLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.shareholderLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.shareholderLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    row.shareholderLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
                <div slot="error" class="image-slot">
                  <div class="legal" :style="'background:'+createRandomColor()+''" v-if="row.shareholderName">
                    <span v-for="(logo,index) of logoword(row.shareholderName)" class="logo-word" v-if="index<4">{{logo}}</span>
                  </div>
                </div>
              </el-image>
              <el-avatar shape="square" fit="contain" style="height: 55px;width: 55px;" v-else>
                <div class="legal" :style="'background:'+createRandomColor()+''" v-if="row.shareholderName">
                  <span v-for="(logo,index) of logoword(row.shareholderName)" class="logo-word" v-if="index<4">{{logo}}</span>
                </div>
              </el-avatar>
              <div style="padding-left: 10px;">
                <el-link :underline="false" style="color: #333;">{{ row.shareholderName }}</el-link>
                <div style="margin-left: -10px;padding-top: 5px;" v-if="row.finalBeneficiary==true || row.actualController==true || row.bigShareholder==true">
                  <i v-if="row.finalBeneficiary==true" class="blue-icon">最终受益人</i>
                  <i v-if="row.actualController==true" class="blue-icon">实际控制人</i>
                  <i v-if="row.bigShareholder==true" class="red-icon">大股东</i>
                </div>
              </div>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="shareholdingRatio" title="持股比例" align="left" width="120">
          <template #default="{ row }">
            <span v-if="row.shareholdingRatio>0">{{ row.shareholdingRatio }}%</span>
          </template>
        </vxe-column>
        <vxe-column field="subscriptionContributionMoney" title="认缴出资额" align="left"></vxe-column>
        <vxe-column field="subscriptionContributionDate" title="认缴出资日期" align="left" width="120"></vxe-column>
      </vxe-table>
    </div>
    <!--主要人员-->
    <div ref="basic3" class="essential-content">
      <div class="title-min SourceHanSansCN">主要人员</div>
      <vxe-table resizable border ref="personnel" :data="personnelKey" align="left"
                 style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
        <vxe-column field="userName" title="姓名">
          <template #default="{ row }">
            <div style="display: flex;align-items: center;">
              <el-avatar shape="square" fit="contain" style="height: 55px;width: 55px;">
                <div class="legal-word" :style="'background:'+createRandomColor()+''" v-if="row.userName">
                  <span v-for="(user_name,index) of logoword(row.userName)" class="logo-word" v-if="index<1">{{user_name}}</span>
                </div>
              </el-avatar>
              <el-link :underline="false" style="padding-left: 10px;color: #333333;">{{ row.userName }}</el-link>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="position" title="职务" width="120"></vxe-column>
        <vxe-column field="shareholdingRatio" title="持股比例"></vxe-column>
        <vxe-column title="最终受益股份" width="120">
          <template #default="{ row }">{{ row.shareholdingRatio }}</template>
        </vxe-column>
      </vxe-table>
    </div>
    <!--对外投资-->
    <div ref="basic4" class="essential-content">
      <div class="title-min SourceHanSansCN">对外投资<span class="quota">{{ tablePage.total }}</span></div>
      <vxe-table resizable border ref="outbound" :data="outboundInvestment" align="center"
                 style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号"></vxe-column>
        <vxe-column field="companyName" title="被投资企业名称" align="left" width="340">
          <template #default="{ row }">
            <div style="display: flex;align-items: center;">
              <el-image shape="square" fit="contain" style="width: 45px;height: 45px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                        draggable="false" :src="row.companyLogo" v-if="row.companyLogo!=null && row.companyLogo!='' && row.companyLogo!='None' &&
                    row.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    row.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
                <div slot="error" class="image-slot">
                  <div class="legal" :style="'background:rgb(39, 64, 139);'" v-if="row.entLogoWord">
                    <span v-for="(logo,index) of logoword(row.entLogoWord)" class="logo-word" v-if="index<4">{{logo}}</span>
                  </div>
                  <div class="legal" :style="'background:'+createRandomColor()+''" v-else>
                    <span v-for="(b,index) of logoword(row.companyName)" class="logo-word" v-if="index<4">{{ b }}</span>
                  </div>
                </div>
              </el-image>
              <el-avatar shape="square" fit="contain" style="height: 55px;width: 55px;" v-else>
                <div class="legal" :style="'background:'+createRandomColor()+''" v-if="row.entLogoWord">
                  <span v-for="(logo,index) of logoword(row.entLogoWord)" class="logo-word" v-if="index<4">{{logo}}</span>
                </div>
                <div class="legal" :style="'background:'+createRandomColor()+''" v-else>
                  <span v-for="(b,index) of logoword(row.companyName)" class="logo-word" v-if="index<4">{{ b }}</span>
                </div>
              </el-avatar>
              <el-link :underline="false" style="padding-left: 10px;color: #0067DD;">{{ row.companyName }}</el-link>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="name" title="法定代表人" align="left"></vxe-column>
        <vxe-column field="registeredCapital" title="注册资本" align="left"></vxe-column>
        <vxe-column field="investmentShareholdingRatio" title="投资比例" align="left"></vxe-column>
        <vxe-column field="investmentMoney" title="投资数额" align="left"></vxe-column>
        <vxe-column field="establishTime" title="成立日期" align="left"></vxe-column>
        <vxe-column field="status" title="状态" align="left">
          <template #default="{ row }">
            <span style="color: #1FC89F;" v-if="row.status=='开业' || row.status=='存续'">{{ row.status }}</span>
            <span style="color: #FE273B;" v-if="row.status=='注销' || row.status=='吊销' ||row.status=='迁出'">
              {{ row.status }}
            </span>
          </template>
        </vxe-column>
        <vxe-column field="financingType" title="融资轮次" align="left"></vxe-column>
        <vxe-column title="融资日期" align="left">
          <template #default="{ row }">
            <span>{{ $moment(row.establishTime).format('YYYY-MM-DD') }}</span>
          </template>
        </vxe-column>
        <vxe-column field="productName" title="关联产品/机构" align="left"></vxe-column>
      </vxe-table>
      <!-- 分页 -->
      <div style="padding:10px 30px; height: 30px;">
        <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
      </div>
    </div>
    <!--最终受益人-->
    <div ref="basic5" class="essential-content">
      <div class="title-min SourceHanSansCN">最终受益人</div>
      <vxe-table resizable border ref="beneficiary" :data="beneficiary" align="center"
                 style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号"></vxe-column>
        <vxe-column field="name" title="最终受益人名称" align="left" width="400">
          <template #default="{ row }">
            <div style="display: flex;align-items: center;">
              <el-avatar shape="square" fit="contain" style="width: 55px;height: 55px;min-width: 55px;min-height: 55px;">
                <div class="legal" :style="'background:'+createRandomColor()+''">
                  <span v-for="(ben_name,index) of logoword(row.name)" class="logo-word" v-if="index<4">{{ben_name}}</span>
                </div>
              </el-avatar>
              <el-link :underline="false" style="padding-left: 10px;color: #333333">{{ row.name }}</el-link>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="shareholdingRatio" title="持股比例" align="left" width="120">
          <template #default="{ row }">
            <span>{{ row.shareholdingRatio }}%</span>
          </template>
        </vxe-column>
        <vxe-column field="equity_chain" title="股权链" align="left">
          <template #default="{ row }">
            <div v-for="(equity,index) in row.equity_chain" style="padding:10px 0px;border-bottom: 1px solid #dddddd;">
              <div>{{ equity.name}}（占比约 {{ equity.investRatio }}%）
                <div style="margin-top: 10px;">
                  <el-link type="primary" :underline="false" @click="enterpriseDetails(row.name)">{{ row.name }}</el-link>
                  <span v-for="equ in equity.equityPath" style="line-height: 32px;">
                    <span class="span-blue">{{equ.investNextRatio || '0%'}}</span>
                    <span style="color: #4C4C4C;font-weight: bold;">----------></span>
                    <el-link type="primary" :underline="false" @click="enterpriseDetail(equ.id)" v-if="equ.type=='company'">{{ equ.name }}</el-link>
                    <span v-else>{{equ.name}}</span>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <!--版权穿透图-->
    <div ref="basic6" class="essential-content">
      <div class="title-min SourceHanSansCN">疑似实际控制人</div>
      <template v-if="ActualControllerBase.length==0">
        <el-empty description="暂无疑似实际控制人"/>
      </template>
      <template v-else>
        <div style="padding: 0px 30px 0px;">
          <div class="light-blue">{{ ActualControllerBase.companyName }}</div>
        </div>
        <div class="relation-group">
          <p>疑似实际控制人（大数据分析）：{{ ActualControllerBase.name }}总股权比例：{{ ActualControllerBase.totalEquityRatio }}%</p>
          <el-avatar class="user-avatar" :style="'background:'+createRandomColor()+''">{{ActualControllerBase.name}}</el-avatar>
          <div class="indicator"><i class="el-icon-caret-bottom"/></div>
          <div style="z-index: 999;margin-top: 125px;">
            <p class="red-label">{{ ActualControllerBase.name }}:{{ ActualControllerBase.totalEquityRatio }}%</p>
          </div>
          <div style="z-index: 999;margin-top: 10px;">
            <p class="label-blue">{{ ActualControllerBase.companyName }}</p>
          </div>
        </div>
      </template>
    </div>
    <!--控股企业-->
    <div ref="basic7" class="essential-content">
      <div class="title-min SourceHanSansCN">控股企业</div>
      <vxe-table resizable border ref="holdingEnterprise" :data="holdingEnterprise" align="center"
                 style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号"></vxe-column>
        <vxe-column field="userName" title="控股企业名称" align="left" width="460">
          <template #default="{ row }">
            <div style="display: flex;align-items: center;">
              <el-image shape="square" fit="contain" style="width: 45px;height: 45px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                        draggable="false" :src="row.companyLogo" v-if="row.companyLogo!=null && row.companyLogo!='' && row.companyLogo!='None' &&
                    row.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    row.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
                <div slot="error" class="image-slot">
                  <div class="legal" :style="'background:rgb(39, 64, 139);'" v-if="row.entLogoWord">
                    <span v-for="(logo,index) of logoword(row.entLogoWord)" class="logo-word" v-if="index<4">{{logo}}</span>
                  </div>
                  <div class="legal" :style="'background:'+createRandomColor()+''" v-else>
                    <span v-for="(b,index) of logoword(row.companyName)" class="logo-word" v-if="index<4">{{ b }}</span>
                  </div>
                </div>
              </el-image>
              <el-avatar shape="square" fit="contain" style="height: 55px;width: 55px;" v-else>
                <div class="legal" :style="'background:rgb(39, 64, 139);'" v-if="row.entLogoWord">
                  <span v-for="(logo,index) of logoword(row.entLogoWord)" class="logo-word" v-if="index<4">{{logo}}</span>
                </div>
                <div class="legal" :style="'background:'+createRandomColor()+''" v-else>
                  <span v-for="(b,index) of logoword(row.companyName)" class="logo-word" v-if="index<4">{{ b }}</span>
                </div>
              </el-avatar>
              <el-link :underline="false" style="padding-left: 10px;color: #0067DD;">{{ row.companyName }}</el-link>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="controlledCompanyProportion" title="投资比例" align="left" width="135">
          <template #default="{ row }">
            <span>{{ row.controlledCompanyProportion }}</span>
          </template>
        </vxe-column>
        <vxe-column title="股权链" align="left">
          <template #default="{ row }">
            <div v-for="(controlled,index) in row.controlledCompanyUrlList">
              <div>路径{{ index + 1 }}（占比约 {{ controlled.percent }}%）</div>
              <div style="margin-top: 10px;">
                <span style="color: #4C4C4C;">{{ basicInfo.companyName }}</span>
                <span v-for="(cont,_index) in row.controlledCompanyUrlList">
                  <span class="span-blue" v-if="_index!=0">{{ cont.percent }}%</span>
                  <span style="color: #CCCCCC;font-weight: bold;" v-if="_index!=0">----------></span>
                  <span style="color: #4C4C4C;" v-if="_index!=0">{{ cont.cname }}</span>
                </span>
              </div>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <!--分支机构-->
    <div ref="basic8" class="essential-content">
      <div class="title-min SourceHanSansCN">分支机构</div>
      <vxe-table resizable border ref="branch" :data="branchItem" align="center" style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号"></vxe-column>
        <vxe-column field="companyName" title="企业名称" align="left">
          <template #default="{ row }">
            <div style="display: flex;align-items: center;">
              <el-image shape="square" fit="contain" style="width: 45px;height: 45px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                        draggable="false" :src="row.companyLogo" v-if="row.companyLogo!=null && row.companyLogo!='' && row.companyLogo!='None' &&
                    row.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    row.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    row.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
                <div slot="error" class="image-slot">
                  <div class="legal" :style="'background:rgb(39, 64, 139);'" v-if="row.entLogoWord">
                    <span v-for="(logo,index) of logoword(row.entLogoWord)" class="logo-word" v-if="index<4">{{logo}}</span>
                  </div>
                  <div class="legal" :style="'background:'+createRandomColor()+''" v-else>
                    <span v-for="(b,index) of logoword(row.companyName)" class="logo-word" v-if="index<4">{{ b }}</span>
                  </div>
                </div>
              </el-image>
              <el-avatar shape="square" fit="contain" style="height: 55px;width: 55px;" v-else>
                <div class="legal" :style="'background:rgb(39, 64, 139);'" v-if="row.entLogoWord">
                  <span v-for="(logo,index) of logoword(row.entLogoWord)" class="logo-word" v-if="index<4">{{logo}}</span>
                </div>
                <div class="legal" :style="'background:'+createRandomColor()+''" v-else>
                  <span v-for="(b,index) of logoword(row.companyName)" class="logo-word" v-if="index<4">{{ b }}</span>
                </div>
              </el-avatar>
              <el-link :underline="false" style="padding-left: 10px;color: #0067DD;" @click="enterpriseDetails(row.companyName)">{{ row.companyName }}</el-link>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="fname" title="负责人" align="left"></vxe-column>
        <vxe-column field="status" title="状态" align="left"></vxe-column>
      </vxe-table>
      <page :total="tablePage2.total" class="pagination" @currentPage="currentPage2" :page="tablePage2.currentPage"
            :limit="tablePage2.pageSize" style="display:flex;justify-content:end;padding:10px 30px;" v-if="tablePage2.total>10"/>
    </div>
    <!--变更记录-->
    <div ref="basic9" class="essential-content">
      <div class="title-min SourceHanSansCN">变更记录</div>
      <vxe-table resizable border ref="Record" :data="changeRecord" align="center"
                 style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号"></vxe-column>
        <vxe-column field="time" title="变更日期" width="120"></vxe-column>
        <vxe-column field="changeProjectName" title="变更项目" width="250"></vxe-column>
        <vxe-column field="beforeChange" title="变更前">
          <template #default="{ row }">
            <div v-html="row.beforeChange" style="text-align: left;padding-left: 20px;"></div>
          </template>
        </vxe-column>
        <vxe-column field="afterChange" title="变更后">
          <template #default="{ row }">
            <div v-html="row.afterChange" style="text-align: left;padding-left: 20px;"></div>
          </template>
        </vxe-column>
      </vxe-table>
      <page :total="tablePage3.total" class="pagination" @currentPage="currentPage3" :page="tablePage3.currentPage"
            :limit="tablePage3.pageSize" style="display:flex;justify-content:end;padding:10px 30px;"
            v-if="tablePage3.total>10"/>
    </div>
    <!--企业年报-->
    <div ref="basic10" class="essential-content">
      <div class="title-min SourceHanSansCN">企业年报</div>
      <vxe-table resizable border ref="annual" :data="annualReport" align="center"
                 style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
        <vxe-column type="seq" width="60" title="序号"></vxe-column>
        <vxe-column field="year" title="发布日期"></vxe-column>
        <vxe-column field="title" title="年报"></vxe-column>
        <vxe-column title="操作" width="150">
          <template #default="{ row }">
            <el-button type="text" style="border: none;background: none;" @click="seeAnnualReportDetail(row.id)">详情
            </el-button>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import SeeksRelationGraph from 'relation-graph'
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";
import {
  getBusinessInformationByCid,
  getCompanyInfo,
  getEquityPenetration,
  getShareholderByCid,
  getMainPersonnelByCid,
  getCcBeneficiary,
  getInvestment,
  getActualController,
  getNewDynamicList,
  getBranch,
  getChangeProjectByCid,
  getAnnualReport,
  getCompanyId
} from '@/api/enterpriseDetailsApi'

Vue.use(VXETable)
export default {
  name: "essentialInfo",
  components: {SeeksRelationGraph, page},
  data() {
    return {
      /*公司id*/
      companyId: '',
      businessData: {},
      /*企业基本信息*/
      basicInfo: {},
      /*股权穿透图参数*/
      g_loading: false,
      graphOptions: {
        'backgrounImageNoRepeat': true,
        'layouts': [
          {
            'label': '手工',
            'layoutName': 'tree',
            'layoutClassName': 'seeks-layout-center',
            'defaultJunctionPoint': 'border',
            "min_per_width": "150",
            'defaultNodeShape': 0,
            'defaultLineShape': 1,
            "distance_coefficient": 1,
            'defaultNodeColor': '#ffffff',
            'defaultNodeFontColor': '#333333',
            'defaultNodeBorderColor': '#CAD1DA',
            'defaultLineColor': '#CAD1DA',
          }
        ],
        'defaultNodeColor': '#ffffff',
        'defaultNodeFontColor': '#333333',
        'defaultNodeBorderColor': '#CAD1DA',
        'defaultLineColor': '#CAD1DA',
        'defaultNodeBorderWidth': 1,
        'defaultNodeShape': 1,
        "allowShowMiniToolBar": true,
        "allowSwitchLineShape": true,
        "allowSwitchJunctionPoint": true,
        'defaultLineShape': 2,
        "hideNodeContentByZoom": true,
        "defaultJunctionPoint": "tb",
        "disableDragNode": true
      },
      currentNode: {},
      isShowNodeTipsPanel: false,
      nodeMenuPanelPosition: {x: 0, y: 0},
      ActualControllerBase: [],
      legalProceedings: [],
      openingAnnouncement: [],
      /*股东信息*/
      ShareholderInfo: [],
      /*主要人员*/
      personnelKey: [],
      /*对外投资*/
      outboundInvestment: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tablePage2: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tablePage3: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      /*最终受益人*/
      beneficiary: [],
      /*控股企业*/
      holdingEnterprise: [],
      /*分支机构*/
      branchItem: [],
      /*变更记录*/
      changeRecord: [],
      /*企业年报*/
      annualReport: [],
    }
  },
  props: {
    corpId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  methods: {
    /*股权穿透图节点明细*/
    showNodeTips(nodeObject, $event) {
      this.currentNode = nodeObject.data
      let _base_position = this.$refs.myPage.getBoundingClientRect()
      this.isShowNodeTipsPanel = true
      this.nodeMenuPanelPosition.x = $event.clientX - _base_position.x + 10
      this.nodeMenuPanelPosition.y = $event.clientY - _base_position.y + 10
    },
    /*隐藏节点明细信息*/
    hideNodeTips() {
      this.isShowNodeTipsPanel = false
    },
    /*查看企业年报详情*/
    seeAnnualReportDetail(id) {
      this.$router.push({path: '/enterpriseDetails/annualReports?id=' + id + '&corpId=' + this.corpId});
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getInvestmentBase();
    },
    /*定位到指定位置*/
    scrollToArea(ref) {
      window.scrollTo(0, this.$refs[ref].offsetTop - 200);
    },
    /*获取工商登记信息*/
    getBusinessInfo() {
      getBusinessInformationByCid({cid: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.businessData = res.content;
          // console.log(res.content);
        }
      })
    },
    /*绘制关系图--股权穿透图*/
    initGrap() {
      getCompanyInfo({id: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.basicInfo = res.content;
          getEquityPenetration({cid: this.corpId, request: 'form'}).then(res => {
            if (res.code == 200) {
              let investment = res.content.investment;
              let shareholder = res.content.shareholder;
              this.$refs.seeksRelationGraph.graphSetting.defaultLineShape = 1;
              let widths = this.basicInfo.companyName.length * 20;
              let __graph_json_data = {
                "rootId": "N1",
                "nodes": [
                  {
                    "id": "N1",
                    "text": this.basicInfo.companyName,
                    "color": "#0067DD",
                    "fontColor": "#ffffff",
                    "borderWidth": 10,
                    "borderColor": "#0067DD",
                    "width": widths,
                    "data": this.basicInfo,
                  }
                ], "links": []
              }
              if (shareholder) {
                shareholder.forEach(function (holder, index) {
                  __graph_json_data.nodes.push({
                    "id": holder.id.toString(),
                    "text": holder.shareholderName + '认缴金额：' + holder.subscriptionContributionMoney,
                    "istop": 'false',
                    "width": 100,
                    "x": 180 * (index + 1), "y": -50,
                  })
                  let shareholdingRatio = '';
                  if (holder.shareholdingRatio != '' && holder.shareholdingRatio != null && holder.shareholdingRatio != undefined) {
                    shareholdingRatio = holder.shareholdingRatio + '%';
                  }
                  __graph_json_data.links.push({
                    "from": holder.id.toString(),
                    "to": "N1",
                    "text": shareholdingRatio,
                    "color": "#DFDFDF",
                    "fontColor": "#0067DD",
                    "lineWidth": 1,
                    "lineShape": 1,
                    "isHideArrow": true
                  })
                })
              }
              if (investment) {
                investment.forEach(function (invest, index) {
                  __graph_json_data.nodes.push({
                    "id": index.toString(),
                    "text": invest.companyName,
                    "istop": 'false',
                    "data": invest,
                    "width": 100,
                    "x": 180 * (index + 1), "y": 400,
                  })
                  __graph_json_data.links.push({
                    "to": index.toString(),
                    "from": 'N1',
                    "text": invest.investmentShareholdingRatio + '%',
                    "color": "#DFDFDF",
                    "fontColor": "#0067DD",
                    "lineWidth": 1,
                    "lineShape": 4,
                  })
                })
              }
              this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, (seeksRGGraph) => {
              })
              setTimeout(function () {
                this.g_loading = false
              }.bind(this), 100)
            }
          })
        }
      })
    },
    /*获取股东信息*/
    getShareholderInfo() {
      getShareholderByCid({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          console.log('股东信息',res.content)
          this.ShareholderInfo = res.content.rows;
        }
      })
    },
    /*主要人员*/
    getPersonnelInfo() {
      getMainPersonnelByCid({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          this.personnelKey = res.content.rows;
          // console.log('主要人员', res.content)
        }
      })
    },
    /*最终受益人*/
    getBeneficiary() {
      getCcBeneficiary({cid: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.beneficiary = res.content;
          // console.log(res.content)
        }
      })
    },
    /*获取对外投资*/
    getInvestmentBase() {
      getInvestment({cid: this.corpId, page: this.tablePage.currentPage, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.outboundInvestment = res.content.rows;
          this.tablePage.total = parseInt(res.content.total);
          // console.log('获取对外投资', res.content)
        }
      })
    },
    /*疑似实际控制人*/
    getActual() {
      getActualController({cid: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log('疑似实际控制人', res.content)
          console.log()
          if (res.content !== undefined && res.content.length > 0) {
            this.ActualControllerBase = res.content[0];
          }
          console.log(this.ActualControllerBase)
        }
      })
    },
    /*控股企业*/
    getDynamicList() {
      getNewDynamicList({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.holdingEnterprise = res.content.rows;
          // console.log(res.content)
        }
      })
    },
    /*分支机构*/
    getBranchData() {
      getBranch({cid: this.corpId, page: this.tablePage2.currentPage, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.branchItem = res.content.rows;
          this.tablePage2.total = parseInt(res.content.total);
          console.log('分支机构', res.content)
        }
      })
    },
    currentPage2(page){
      this.tablePage2.currentPage=page;
      this.getBranchData();
    },
    /*变更记录*/
    getChangeProject() {
      getChangeProjectByCid({cid: this.corpId, page: this.tablePage3.currentPage, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.changeRecord = res.content.rows;
          this.tablePage3.total = parseInt(res.content.total);
          console.log('变更记录', res.content)
        }
      })
    },
    currentPage3(page){
      this.tablePage3.currentPage=page;
      this.getChangeProject();
    },
    /*获取企业年报*/
    getAnnualReportInfo() {
      getAnnualReport({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.annualReport = res.content.rows;
          // console.log(res.content)
        }
      })
    },
    /*随机生成颜色值*/
    createRandomColor() {
      let num = Math.floor(Math.random() * 9 + 1);
      let colorList = ['#7db3d9', '#d1ae9d', '#ca8484', '#bc9edd', '#8B658B', '#B22222', '#27408B', '#008B8B', '#5D478B', '#68228B'];
      return colorList[num];
    },
    clearString(s){
      let reg=new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）&;|{}【】‘；：”“'。，、？]")
      let rs="";
      for (let i=0;i<s.length;i++){
        rs=rs+s.substr(i,1).replace(reg,'');
      }
      return rs;
    },
    /**
     * @event 通过公司id获取公司id跳转公司详情
     * 当通过公司名称未获取到公司id则不跳转公司详情
     */
    enterpriseDetails(companyName){
      getCompanyId({companyName: companyName, request: 'form'}).then(res => {
        if (res.code == 200) {
          if (res.content!=0){
            let routeData = this.$router.resolve({
              name: "enterpriseDetails",
              path: '/enterpriseDetails/index',
              query: {id: res.content},
            });
            window.open(routeData.href, '_blank')
          }
        }
      })
    },
  },
  computed: {
    logoword() {
      return function (word) {
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  mounted() {
    this.getBusinessInfo();
    this.initGrap();
    this.getShareholderInfo();
    this.getPersonnelInfo();
    this.getBeneficiary();
    this.getInvestmentBase();
    this.getActual();
    this.getDynamicList();
    this.getBranchData();
    this.getChangeProject();
    this.getAnnualReportInfo();
  }
}
</script>
<style lang="scss" scoped>
.essential {
  .business {
    background: white;

    .business-table {
      table-layout: fixed;
      display: contents;
      border-collapse: separate;
      box-sizing: border-box;
      text-indent: initial;
      border-spacing: 2px;
      border-color: grey;

      tr {
        border-spacing: 0px;
      }

      .col-td4 {
        padding: 15px 10px 15px 20px;
        background: #F3F9FC;
        text-align: left;
        color: #333333;
        border: 0.5px solid #E5EEF6;
        width: 15%;
        border-spacing: 0px;
      }

      .col-td7 {
        padding: 15px 10px;
        background: #ffffff;
        text-align: left;
        width: 20%;
        border-spacing: 0px;
        border: 0.5px solid #E5EEF6;
        word-wrap: break-word;
      }

      .col-td6 {
        padding: 15px 10px;
        background: #ffffff;
        text-align: left;
        width: 20%;
        border-spacing: 0px;
        border: 0.5px solid #E5EEF6;
        word-wrap: break-word;
      }

      .col-td5 {
        padding: 15px 10px;
        background: #ffffff;
        text-align: left;
        width: auto;
        border: 0.5px solid #E5EEF6;
        border-spacing: 0px;
      }

      .border-left {
        border: 1px solid #E5EEF6;
      }
    }
  }

  .essential-content {
    background: white;
    margin-top: 10px;
    padding-bottom: 20px;

    .light-blue {
      background: #F1F7FC;
      border: 0.5pt solid #e5eef6;
      padding: 20px;
    }

    .avatar-title {
      text-align: left;
      color: #333333;
      padding-top: 10px;
      line-height: revert;
    }

    .graph {
      z-index: 999;
      padding: 10px;
      background-color: #ffffff;
      border: #eeeeee solid 1px;
      box-shadow: 0px 0px 8px #cccccc;
      position: absolute;
      width: auto;
      display: -webkit-inline-box;
    }

    .span-blue {
      position: absolute;
      margin-top: -10px;
      margin-left: 15px;
      color: #2B79FE;
    }
    .relation-group {
      text-align: center;
      border: 1px solid #E5EEF6;
      margin: 0px 30px;
      padding: 30px 0px;

      .label-blue {
        background: #0067DD;
        display: inline-block;
        padding: 15px 25px;
        color: #ffffff;
        font-family: 'SourceHanSansCN';
        border-radius: 8px;
        font-size: 16px;
      }

      .red-label {
        background: #FE273B;
        display: inline-block;
        padding: 6px 12px;
        color: #ffffff;
        font-family: 'SourceHanSansCN';
        border-radius: 8px;
        font-size: 14px;
      }

      .indicator {
        width: 1px;
        background: #FE273B;
        height: 90px;
        position: absolute;
        margin-left: 30.5%;
        z-index: 80;
        margin-top: 99px;

        .el-icon-caret-bottom {
          color: rgb(254, 39, 59);
          position: absolute;
          margin-top: 83px;
          margin-left: -11px;
          font-size: 20px;
        }
      }

      .user-avatar {
        color: #ffffff;
        position: absolute;
        border-radius: 50%;
        margin-left: -47px;
        width: 100px;
        border: 1px solid #FE273B;
        height: 100px;
        line-height: 100px;
        font-size: 22px;
      }
    }
  }

  .title-min {
    padding: 20px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #222222;
  }
  .legal {
    height: 55px;
    width: 55px;
    font-size: 12px;
    color: #ffffff;
    font-weight: 500;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0px;
    border-radius: 8px;

    .logo-word {
      width: 34%;
      height: 34%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .legal-word {
    height: 55px;
    width: 55px;
    font-size: 16px;
    color: #ffffff;
    font-weight: bold;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0px;
    border-radius: 8px;

    .logo-word {
      width: 34%;
      height: 34%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .el-avatar {
    background: white;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: 8px;
    height: 50px;
    width: 50px;
    line-height: 48px;
    float: left;
    color: #333333;
  }

  .red-icon {
    color: #F6243F;
    background: #FEEFF2;
    font-size: 12px;
    font-family: "SourceHanSansCN";
    font-style: normal;
    padding: 5px 6px;
    margin-left: 10px;
    cursor: pointer;
  }

  .blue-icon {
    color: #1935DE;
    background: #E0E4FF;
    font-size: 12px;
    font-family: "SourceHanSansCN";
    font-style: normal;
    padding: 5px 6px;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>